// ForgotPasswordModal.js
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Icon from "../common/icons";
import { useModalInstance, useModal } from "react-modal-state"; // Correct import
import api from "../../utils/api"; // Your API utility
import { toast } from "react-toastify";

const ForgotPasswordModal = () => {
  const { isOpen, close, data } = useModalInstance(); // Handles the current modal (ForgotPasswordModal)
  const { open: openLoginModal } = useModal("login"); // To open login modal
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false); // Track the submission state

  // Start from the email typed in Sign In. This modal stays mounted between opens,
  // so take it each time it opens rather than only on first render.
  useEffect(() => {
    if (isOpen && data?.email) setEmail(data.email);
  }, [isOpen, data]);

  // Email validation function
  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate email format
    if (!isValidEmail(email)) {
      toast.error("Invalid email format.");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await api.post("/auth/request-password-reset/", {
        email,
      });
      if (response.status === 200) {
        // The server answers the same whether or not the email has an account
        toast.success("If that email has an Anna account, we sent a reset link. Check your inbox.");
        close();
      }
    } catch (error) {
      toast.error(
        "Failed to send password reset email. Please try again later.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleBackToLogin = () => {
    close();
    setTimeout(() => {
      openLoginModal({ email: email.trim() });
    }, 300);
  };

  return (
    <Modal show={isOpen} onHide={close} dialogClassName="am-auth-dialog" centered aria-labelledby="forgot-title">
      <Modal.Header closeButton>
        <Modal.Title id="forgot-title">Forgot Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit} className="am-form">
          <div className="am-intro">
            <span className="am-intro-icon">
              <Icon name="key" size={28} />
            </span>
            <h3 className="am-intro-title">Reset your password</h3>
            <p className="am-intro-text">
              Enter your email address and we'll send you a link to reset your
              password.
            </p>
          </div>

          <label className="am-field">
            <span className="am-label">Email address</span>
            <span className="am-input">
              <Icon name="mail" size={20} />
              <input
                type="email"
                placeholder="you@example.com"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isSubmitting}
              />
            </span>
          </label>

          <button
            className="am-btn is-primary is-block is-large"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="spinner-border" role="status" aria-hidden="true" />
                Sending reset email...
              </>
            ) : (
              <>
                <Icon name="send" size={18} />
                Send reset email
              </>
            )}
          </button>

          <p className="am-note">
            <Icon name="info" size={18} />
            <span>Check your email inbox and spam folder for the reset link.</span>
          </p>
        </form>
      </Modal.Body>
      <Modal.Footer className="am-foot-split">
        <button type="button" className="am-btn" onClick={handleBackToLogin}>
          <Icon name="arrow-left" size={18} />
          Back to Sign In
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ForgotPasswordModal;
